import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

import styles from './styles.module.scss';

interface OwnProps {
	isVisible: boolean;
	onEditRates(): void;
	onDelete(): void;
	onMarkAsDefaultOnJob(): void;
	onRemoveAsDefaultOnJob(): void;
}

type Props = OwnProps;

const MaterialBulkControls: React.FC<Props> = (props) => {
	const { isVisible, onEditRates, onDelete, onMarkAsDefaultOnJob, onRemoveAsDefaultOnJob } = props;

	if (!isVisible) {
		return null;
	}

	return (
		<div className={styles.materialBulkControls}>
			<Button
				customStyleClass={styles.action}
				icon="ActionEdit"
				label="Edit Rates"
				onClick={onEditRates}
				style="link"
			/>
			<Button
				customStyleClass={styles.action}
				icon="Check"
				label="Mark as Job Default"
				onClick={onMarkAsDefaultOnJob}
				style="link"
			/>
			<Button
				customStyleClass={styles.action}
				icon="MarkStopCircle"
				label="Remove as Job Default"
				onClick={onRemoveAsDefaultOnJob}
				style="link"
			/>
			<Button
				customStyleClass={styles.action}
				icon="Delete"
				label="Delete"
				onClick={onDelete}
				style="link"
			/>
		</div>
	);
};

export default MaterialBulkControls;
